module.exports = __webpack_public_path__ + "img/logo-calumis.abdad4bb.png";